export const GET_GUIDE_CLASSIFICATIONS = "GET_GUIDE_CLASSIFICATIONS"
export const GET_GUIDE_CLASSIFICATIONS_SUCCESS = "GET_GUIDE_CLASSIFICATIONS_SUCCESS"
export const GET_GUIDE_CLASSIFICATIONS_FAIL = "GET_GUIDE_CLASSIFICATIONS_FAIL"

export const ADD_GUIDE_CLASSIFICATION = "ADD_GUIDE_CLASSIFICATION"
export const ADD_GUIDE_CLASSIFICATION_SUCCESS = "ADD_GUIDE_CLASSIFICATION_SUCCESS"
export const ADD_GUIDE_CLASSIFICATION_FAIL = "ADD_GUIDE_CLASSIFICATION_FAIL"

export const UPDATE_GUIDE_CLASSIFICATION = "UPDATE_GUIDE_CLASSIFICATION"
export const UPDATE_GUIDE_CLASSIFICATION_SUCCESS = "UPDATE_GUIDE_CLASSIFICATION_SUCCESS"
export const UPDATE_GUIDE_CLASSIFICATION_FAIL = "UPDATE_GUIDE_CLASSIFICATION_FAIL"

export const DELETE_GUIDE_CLASSIFICATION = "DELETE_GUIDE_CLASSIFICATION"
export const DELETE_GUIDE_CLASSIFICATION_SUCCESS = "DELETE_GUIDE_CLASSIFICATION_SUCCESS"
export const DELETE_GUIDE_CLASSIFICATION_FAIL = "DELETE_GUIDE_CLASSIFICATION_FAIL"

export const SET_GUIDE_CLASSIFICATION_FIELD_ERRORS = "SET_GUIDE_CLASSIFICATION_FIELD_ERRORS"
